import React, { FC, useState } from 'react';
import { Menu, Popup } from 'semantic-ui-react';
import { SidebarIcons } from '../../../types/sidebar';
import SidebarIcon from '../SidebarIcon';

export interface MenuItemProps {
    iconName: SidebarIcons;
    name: string;
    disable: boolean;
    barColor?: string;
    isHovered?: boolean;
}

const MenuItem: FC<MenuItemProps> = ({ iconName, name, disable, barColor, isHovered = false }) => {
    const [isHovering, setIsHovering] = useState(false);

    const isBarLayout = Boolean(barColor);

    if (isBarLayout) {
        return (
            <div
                style={{
                    height: '100%',
                    minHeight: '6.875rem',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0.75rem 0',
                    boxSizing: 'border-box',
                    cursor: 'pointer',
                    backgroundColor: isHovered ? 'rgba(0, 0, 0, 0.12)' : 'transparent',
                    borderRadius: '0.3125rem',
                    transition: 'background-color 0.15s ease',
                    overflow: 'visible',
                }}
            >
                <div
                    style={{
                        width: '3rem',
                        minHeight: '3rem',
                        flexShrink: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '0.5rem',
                        overflow: 'visible',
                    }}
                >
                    <SidebarIcon white={true} name={iconName} />
                </div>
                <div
                    style={{
                        color: 'white',
                        fontSize: 'clamp(0.875rem, 2vw, 1.25rem)',
                        fontFamily: 'Lato, sans-serif',
                        fontWeight: 700,
                        lineHeight: 1.25,
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}
                >
                    {name}
                </div>
            </div>
        );
    }

    return (
        <div onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
            <Menu.Item
                disabled={disable}
                className='menu-item'
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: isHovering ? 'rgba(41, 135, 205, 0.08)' : '#fff',
                    border: 'none',
                    padding: '17px',
                }}
            >
                <Popup
                    content={name.replace(name[0], name[0].toUpperCase())}
                    trigger={<SidebarIcon white={false} name={iconName} />}
                    open={isHovering}
                    size="tiny"
                    position="right center"
                />
            </Menu.Item>
        </div>
    );
};

export default MenuItem;